require('./Legacy/cookies.js')
require('./Legacy/popups.js')
require('./Legacy/dom-prototype.js')
require('./Legacy/star-ratings.js')
require('./Legacy/profile-links.js')

require('./Foundation/Foundation.js')
require('./Foundation/Scanner.js')
require('./Foundation/Path.js')
require('./Foundation/Cookie.js')
require('./Foundation/Geo.js')
require('./Foundation/Observable/Observable.js')
require('./Foundation/Observable/Event.js')
require('./Foundation/NotificationCenter.js')
require('./Foundation/Promise/Promise.js')
require('./Foundation/Promise/Queue.js')
require('./Foundation/Timer/Timer.js')
require('./Foundation/Timer/Persistent.js')
require('./Foundation/URL.js')
require('./Foundation/Script.js')
require('./Foundation/Environment.js')
require('./Foundation/Storable/Storable.js')
require('./Foundation/Storable/Bucket.js')
require('./Foundation/Storable/WebStorageAbstractFactory.js')
require('./Foundation/Storable/WebStorageEmulator.js')
require('./Foundation/Storable/StorageEventDispatcher.js')
require('./Foundation/API.js')
require('./Foundation/Object.js')
require('./Foundation/Member/Member.js')
require('./Foundation/Member/Setting.js')
require('./Foundation/Image/Image.js')
require('./Foundation/ViewController.js')
require('./Foundation/Component/Component.js')
require('./Foundation/Component/Ajax.js')
require('./Foundation/Session/Session.js')
require('./Foundation/Session/Manager/Manager.js')
require('./Foundation/Session/Manager/Delegate.js')
require('./Foundation/Login/Login.js')
require('./Foundation/Login/Attempt.js')
require('./Foundation/Login/ThirdPartyAuthenticator.js')
require('./Foundation/Login/SessionManagerDelegate.js')
require('./Foundation/Login/Dialog/Dialog.js')
require('./Foundation/MobileDetectComponent.js')
require('./Foundation/LoginRequiredComponent.js')
require('./Foundation/PostCommentComponent.js')
require('./Foundation/WindowDimensions.js')
require('./Foundation/Dev/Dev.js')
require('./Foundation/Dev/ComponentInspector.js')
require('./Foundation/Facebook/Facebook.js')
require('./Foundation/Facebook/API.js')
require('./Foundation/Facebook/Application.js')
require('./Foundation/Facebook/User.js')
require('./Foundation/Facebook/Authenticator.js')
require('./Foundation/Facebook/SessionManagerDelegate.js')
require('./Foundation/Google/Google.js')
require('./Foundation/Google/Authenticator.js')
require('./Foundation/Google/SessionManagerDelegate.js')
require('./Foundation/Twitter/Twitter.js')
require('./Foundation/Twitter/Authenticator.js')
require('./Foundation/Twitter/SessionManagerDelegate.js')
require('./Foundation/Tools.js')
require('./Foundation/Ajax.js')
require('./Foundation/Paginator.js')
require('./Foundation/Shadowbox.js')
require('./Foundation/View/View.js')
require('./Foundation/View/Interface/Interface.js')
require('./Foundation/View/Interface/ModalDialog.js')
require('./Foundation/View/Desktop/Fancybox.js')
require('./Foundation/View/Desktop/NavigationPanel.js')
require('./Foundation/View/Desktop/RevealPanel.js')
require('./Foundation/View/ModalDialog.js')
require('./Foundation/View/Interface/Spinner.js')
require('./Foundation/View/Desktop/Spinner.js')
require('./Foundation/View/Spinner.js')
require('./Foundation/Spinner.js')
require('./Foundation/View/Interface/ErrorList.js')
require('./Foundation/View/Desktop/ErrorList.js')
require('./Foundation/View/ErrorList.js')
require('./Foundation/Form/Form.js')
require('./Foundation/Form/Validator/Validator.js')
require('./Foundation/Form/Validator/Required.js')
require('./Foundation/Form/Validator/Email.js')
require('./Foundation/Form/Validator/Confirm.js')
require('./Foundation/Form/Validator/Login.js')
require('./Foundation/Form/Validator/ReCaptcha.js')
require('./Foundation/Form/Captcha.js')
require('./Foundation/Form/ReCaptcha.js')
require('./Foundation/Form/FileInput.js')


// Date picker polyfill
require('flatpickr')
require("flatpickr/dist/themes/airbnb.css")
